/**
 * Copyright 2026 Bluecircle Technologies Pvt Limited. All rights reserved.
 *
 * This software and its source code are the proprietary and confidential
 * intellectual property of Bluecircle Technologies Pvt Limited. Unauthorized
 * copying, reproduction, distribution, modification, public display, or use
 * of this software, in whole or in part, is strictly prohibited without the
 * prior written permission of Bluecircle Technologies Pvt Limited.
 *
 * Portions derived from Grist (Copyright Grist Labs), used under the Apache
 * License, Version 2.0. See the NOTICE file for details.
 */

import * as Bowser from "bowser"; // TypeScript

let parser: Bowser.Parser.Parser | undefined;

function getParser() {
  return parser || (parser = Bowser.getParser(window.navigator.userAgent));
}

// Returns whether the browser we are in is a desktop browser.
export function isDesktop() {
  const platformType = getParser().getPlatformType();
  return (!platformType || platformType === "desktop");
}

// Returns whether the browser is on mobile iOS.
// This is used in particular in viewport.ts to set maximum-scale=1 (to prevent iOS auto-zoom when
// an input is focused, without preventing manual pinch-to-zoom).
export function isIOS() {
  return navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform);
}

// Returns 'metaKey' on Mac / iOS, and 'ctrlKey' elsewhere. This is useful for various keyboard
// interactions that use Control on Windows and Linux, and Command key on Mac for the same
// purpose. Suitable to use with KeyboardEvent and MouseEvent.
// (Note: Mousetrap.js uses the same logic to interpret its "mod" key alias.)
export function modKeyProp(): "metaKey" | "ctrlKey" {
  return /Mac|iPod|iPhone|iPad/.test(navigator.platform) ? "metaKey" : "ctrlKey";
}

export function isWin() {
  const os = getParser().getOSName();
  return os === "Windows";
}
